export default "__VITE_ASSET__rUlhGj9k__"